import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import TabWrapper from 'components/shared/profile-tabs/tab-wrapper';
import TeamContent from 'components/team-profile/team-tab/team-content';
import {
  changeTeamSeason,
  changeTeamSort,
  fetchTeamAthletes,
  followFeedUser,
  unfollowFeedUser,
} from 'common/actions';

class TeamTab extends React.Component {
  static propTypes = {
    dispatch: React.PropTypes.func.isRequired,
    user: React.PropTypes.object,
    team: React.PropTypes.shape({
      teamId: React.PropTypes.string.isRequired,
    }).isRequired,
    roster: React.PropTypes.shape({
      seasons: React.PropTypes.arrayOf(React.PropTypes.shape({
        seasonId: React.PropTypes.string.isRequired,
        seasonYear: React.PropTypes.number.isRequired,
        isSelected: React.PropTypes.bool,
        athleteRequestComplete: React.PropTypes.bool,
        athleteLoadError: React.PropTypes.instanceOf(Error),
      })).isRequired,
      teamSortType: React.PropTypes.string,
    }),
    isMobile: React.PropTypes.bool.isRequired,
    seoFriendlyName: React.PropTypes.string.isRequired,
    forcePublicView: React.PropTypes.bool,
  }

  componentDidMount() {
    // Load selected season if it hasn't been already
    const season = this.props.roster.seasons.find((s) => s.isSelected); // eslint-disable-line react/prop-types
    if (season && (!season.athleteRequestComplete || season.athleteLoadError)) {
      this.props.dispatch(fetchTeamAthletes(season.seasonId));
    }
  }

  onSeasonSelect(seasonOption) {
    const season = this.props.roster.seasons.find(
      (s) => s.seasonId === seasonOption.value); // eslint-disable-line react/prop-types, max-len
    this.props.dispatch(changeTeamSeason(seasonOption.value));
    if (season && (!season.athleteRequestComplete || season.athleteLoadError)) {
      this.props.dispatch(fetchTeamAthletes(seasonOption.value));
    }
  }

  onSortSelect(sortType) {
    this.props.dispatch(changeTeamSort(sortType));
  }

  onFollowUnfollow(feedUserTypeId, feedUserRelatedId, isFollow) {
    if (isFollow) {
      this.props.dispatch(followFeedUser(feedUserTypeId, feedUserRelatedId));
    } else {
      this.props.dispatch(unfollowFeedUser(feedUserTypeId, feedUserRelatedId));
    }
  }

  onChangeTab(name, changeWindowLocation) {
    const dispatch = this.props.dispatch;
    let newRoute = `/team/v2/${this.props.team.teamId}/${this.props.seoFriendlyName}/${name}`;
    newRoute += document.location.search + document.location.hash;
    if (changeWindowLocation) {
      window.location = window.location.origin + newRoute;
    } else {
      dispatch(routerActions.push(newRoute));
    }
  }

  render() {
    return (
      <TabWrapper>
        <main className="tab-panel team-tab">
          <TeamContent
            forcePublicView={this.props.forcePublicView}
            user={this.props.user}
            team={this.props.team}
            seasons={this.props.roster.seasons}
            teamSortType={this.props.roster.teamSortType}
            onSeasonSelect={this.onSeasonSelect.bind(this)}
            onSortSelect={this.onSortSelect.bind(this)}
            onFollowUnfollow={this.onFollowUnfollow.bind(this)}
            onChangeTab={this.onChangeTab.bind(this)}
          />
        </main>
      </TabWrapper>
    );
  }
}

function select(state) {
  return state;
}

export default connect(select)(TeamTab);
